export const llHlsDefaults = Object.freeze({
  hlsPlaybackUrl: "",
  hlsSegmentFormat: "mpegts", hlsBindAddress: "127.0.0.1", hlsAdvertisedHost: "",
  hlsTlsCertificatePath: "", hlsTlsKeyPath: "",
  hlsPort: 0, hlsSegmentDurationMs: 2000, hlsPartDurationMs: 200, hlsWindowSegments: 15,
});
export function normalizeLlHls(value = {}) {
  return Object.fromEntries(Object.entries(llHlsDefaults).map(([key, fallback]) => [key, value?.[key] ?? fallback]));
}
export function validateLlHls(value) {
  const v = normalizeLlHls(value);
  if (String(v.hlsPlaybackUrl).trim()) {
    try {
      const raw = String(v.hlsPlaybackUrl).trim(), url = new URL(raw);
      const path = raw.match(/^https?:\/\/[^/]+(\/[^?#]*)$/)?.[1];
      if (!path || !/^(\/[A-Za-z0-9_-]+)*\/index\.m3u8$/.test(path) ||
          url.username || url.password || url.search || url.hash || url.port === "0" || ["0.0.0.0","[::]"].includes(url.hostname)) throw Error();
      if ((url.protocol === "https:") !== Boolean(v.hlsTlsCertificatePath && v.hlsTlsKeyPath)) return "HTTPS requires TLS certificate and key; use HTTPS when TLS is configured";
    } catch { return "Enter an HTTP(S) playback URL ending in /index.m3u8, with a fixed port and plain path names"; }
  }
  if (!["mpegts", "mp4"].includes(v.hlsSegmentFormat)) return "Choose MPEG-TS or Fragmented MP4";
  for (const [key, min, max, label] of [
    ["hlsPort", 0, 65535, "Media port"], ["hlsSegmentDurationMs", 1000, 10000, "Segment duration"],
    ["hlsPartDurationMs", 100, 1000, "Part duration"], ["hlsWindowSegments", 6, 120, "Live window"],
  ]) {
    if (key === "hlsPort" && String(v.hlsPlaybackUrl).trim()) continue;
    if (String(v[key]).trim() === "" || !Number.isInteger(Number(v[key])) || Number(v[key]) < min || Number(v[key]) > max)
      return `${label} must be an integer from ${min} to ${max}`;
  }
  if (Number(v.hlsSegmentDurationMs) < 3 * Number(v.hlsPartDurationMs)) return "Each segment must contain at least three parts";
  if (!v.hlsBindAddress.trim()) return "Media bind address is required";
  if (["0.0.0.0", "::"].includes(v.hlsBindAddress) && !v.hlsAdvertisedHost.trim() && !v.hlsPlaybackUrl.trim()) return "Enter the hostname or IP viewers will use";
  if (Boolean(v.hlsTlsCertificatePath.trim()) !== Boolean(v.hlsTlsKeyPath.trim())) return "Provide both TLS certificate and private key paths";
  return "";
}
export function llHlsPayload(value) {
  const normalized = normalizeLlHls(value);
  const error = validateLlHls(normalized);
  if (error) throw new Error(error);
  return Object.fromEntries(Object.entries(normalized).map(([key, value]) => [key,
    typeof llHlsDefaults[key] === "number" ? Number(value) : String(value).trim()]));
}
